import { ISD_CODE_LENGTH, PH_ISD_CODE } from '../../common';

type UseViewModelReturn = {
  getIsdCode: () => string;
  getPhoneNumberWithCode: () => string;
};

const useViewModel = (phoneNumber: string): UseViewModelReturn => {
  const isPhoneNumberWithCode = (): boolean => {
    if (phoneNumber.includes('+') && phoneNumber.length > ISD_CODE_LENGTH) {
      return true;
    }
    return false;
  };

  const getIsdCode = (): string => {
    if (isPhoneNumberWithCode()) {
      return phoneNumber.substring(0, ISD_CODE_LENGTH);
    }
    return PH_ISD_CODE;
  };

  const getPhoneNumberWithCode = (): string => {
    if (!phoneNumber) {
      return '---';
    }
    if (phoneNumber.includes('+')) {
      return phoneNumber;
    }
    return `${PH_ISD_CODE}${phoneNumber}`;
  };

  return {
    getIsdCode,
    getPhoneNumberWithCode,
  };
};

export default useViewModel;
